
import { mapState, mapGetters } from 'vuex'

export default {
  filters: {
    hideMonth(subscriptionName) {
      const newSubName = subscriptionName.split(' - Jul20')
      return newSubName[0]
    },
  },

  components: {
    Notifications: () => import('~/components/notifications/Index.vue'),
  },

  data() {
    return {
      windowSize: {
        x: 0,
        y: 0,
      },
    }
  },

  computed: {
    ...mapState('dashboardState', {
      loading: 'loading',
    }),
    ...mapGetters('account', {
      subscriptions: 'subscriptions',
    }),

    userName() {
      const authUser = this.$auth.$storage.getState('user')

      return authUser ? authUser.name.split(' ')[0] : ''
    },
    userImage() {
      const authUser = this.$auth.$storage.getState('user')

      return authUser ? authUser.image : ''
    },
    user() {
      return this.$auth.$storage.getState('user')
    },
    isDesigner() {
      if (!this.user) {
        return false
      }

      return (
        this.user.roles.includes('designer') &&
        (!this.user.roles.includes('design-leader') ||
          !this.user.roles.includes('is-admin'))
      )
    },
    isDesignLeader() {
      if (!this.user) {
        return false
      }

      return (
        this.user.roles.includes('design-leader') &&
        (!this.user.roles.includes('designer') ||
          !this.user.roles.includes('is-admin'))
      )
    },
    toolsItems() {
      if (this.isDesigner) {
        return [
          {
            name: 'Kanban',
            isExternal: false,
            route: '/kanban',
            icon: 'fab fa-trello',
          },
          {
            name: 'Employee Tools',
            isExternal: true,
            route: 'https://intra.thefutures.io/',
            icon: 'fa fa-calendar-check',
          },
        ]
      }

      if (this.isDesignLeader) {
        return [
          {
            name: 'Kanban',
            isExternal: false,
            route: '/kanban',
            icon: 'fab fa-trello',
          },
          // {
          //   name: 'Create User',
          //   isExternal: false,
          //   route: '/users/create',
          //   icon: 'fas fa-user',
          // },
          {
            name: 'Client List',
            isExternal: false,
            route: '/cx/clients',
            icon: 'fas fa-list-alt',
          },
          {
            name: 'Employee Tools',
            isExternal: true,
            route: 'https://intra.thefutures.io/',
            icon: 'fa fa-calendar-check',
          },
          {
            name: 'Client Panel',
            isExternal: false,
            route: '/tickets',
            icon: 'fa fa-columns',
          },
          // {
          //   name: 'View As',
          //   isExternal: false,
          //   route: '/view-as',
          //   icon: 'fas fa-eye',
          // },
        ]
      }

      // is admin
      return [
        {
          name: 'Kanban',
          isExternal: false,
          route: '/kanban',
          icon: 'fab fa-trello',
        },
        {
          name: 'Create User',
          isExternal: false,
          route: '/users/create',
          icon: 'fas fa-user',
        },
        {
          name: 'Client List',
          isExternal: false,
          route: '/cx/clients',
          icon: 'fas fa-list-alt',
        },
        {
          name: 'Employee Tools',
          isExternal: true,
          route: 'https://intra.thefutures.io/',
          icon: 'fa fa-calendar-check',
        },
        {
          name: 'Client Panel',
          isExternal: false,
          route: '/tickets',
          icon: 'fa fa-columns',
        },
        {
          name: 'View As',
          isExternal: false,
          route: '/view-as',
          icon: 'fas fa-eye',
        },
      ]
    },
    companyName() {
      if (this.currentUser) {
        if (this.currentUser.company) return this.currentUser.company.name
      }

      return false
    },

    payload() {
      const authUser = this.$auth.$storage.getState('user')

      return {
        userId: authUser.sub,
        authToken: this.$auth.$storage.getUniversal('_token.cookie'),
      }
    },
  },

  mounted() {
    // this.$vuetify.theme.dark = false
    this.onResize()
  },

  methods: {
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight }
    },

    // ...mapActions('account', {
    //   getUserAccount: 'getUserAccount',
    //   getDataUser: 'getDataUser',
    // }),
  },
}
